import { atom } from 'recoil';
import { Address } from '../interfaces/Address/Address';

export const addressesAtom = atom<Address[]>({
  key: 'addressesState',
  default: [],
});
